import { DiscountDistributionMethod } from "@redotech/redo-return-core-common/exchange-settings";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

export const discountDistributionSettingsShape = {
  discountDistribution: z.object({
    method: createEnum(DiscountDistributionMethod).nullable(),
    redistributeBogoDiscounts: z.boolean(),
  }),
};

export type DiscountDistributionSettings = z.infer<
  z.ZodObject<typeof discountDistributionSettingsShape>
>;

export function discountDistributionSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): DiscountDistributionSettings {
  return {
    discountDistribution: {
      method: settings.discountDistributionMethod ?? null,
      redistributeBogoDiscounts: !!settings.returns?.redistributeBogoDiscounts,
    },
  };
}

export function discountDistributionTeamPatch({
  discountDistribution,
}: DiscountDistributionSettings): PortalSettingsPatch {
  const set: Record<string, unknown> = {
    "returns.redistributeBogoDiscounts":
      discountDistribution.redistributeBogoDiscounts,
  };
  const unset: string[] = [];
  if (discountDistribution.method === null) {
    unset.push("discountDistributionMethod");
  } else {
    set.discountDistributionMethod = discountDistribution.method;
  }
  return { set, unset };
}
